export const SETTINGS_ROUTE_NAMES = {
    INDEX: "SettingsIndex",
    QUICK_START: "SettingsQuickStart",
    CATEGORY_EDITOR: "SettingsCategoryEditor",
    REPAIR_FORM: "SettingsRepairForm",
    CONTRACTS_LIST: "SettingsContractsList",
    CONTRACTS_ADD: "SettingsContractsAdd",
    CONTRACTS_EDIT: "SettingsContractsEdit",
    INTEGRATIONS: "SettingsIntegrations",
    IMPORT: "SettingsImport",
};
